// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
// Tested with react-native 0.17.7
export function reactNativeDetect() {
    return (typeof navigator !== 'undefined' &&
        typeof navigator.product !== 'undefined' &&
        navigator.product === 'ReactNative');
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/cache/node_modules/@aws-amplify/core/lib-esm/Platform/detection/ReactNative.js
// module id = null
// module chunks = 